import React from "react";
import { Row, Col, Container, Image } from 'react-bootstrap';
import logo from "../assets/img/Footer.png";
import Awards from "../assets/img/awards.png";
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import licenceBondImage from "../assets/img/licensed-bonded-insured.png"
import {
    COMPANY_ADDRESS_LINE,
    COMPANY_FOOTER_LICENSE_LINE,
    COMPANY_NAME,
    COMPANY_PHONE_DISPLAY,
    COMPANY_PHONE_HREF,
    COMPANY_MAPS_SEARCH_URL,
} from "../constants/company"
import { appPath } from "../utils/appPaths";

const Footer = () => {

    return (
        <footer className="footer">
            <Container>
                <div className="footertop">
                    <Row>
                        <Col lg={3}>
                            <div className="footer-column pe-xl-5">
                                <Link to="/" className="footerlogo">
                                    <img src={logo} alt={COMPANY_NAME} />
                                </Link>
                                <p className="mb-0">We specialize in home remodeling helping home owners from start to finish. We help with initial consultation, 
                                design phase, permitting, full service construction, and more!</p>
                            </div>
                        </Col>
                        <Col lg={{ span: 2, offset: 1 }}>
                            <div className="footer-column">
                                <h2 className="footer-heading">Quick Links</h2>
                                <ul className="footer-menu list-unstyled">
                                    <li><Link to="/ourprojects">Our Projects</Link></li>
                                    <li><Link to="/aboutus">About Us</Link></li>
                                </ul>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="footer-column">
                                <h2 className="footer-heading">Contact</h2>
                                <ul className="footer-contact list-unstyled">
                                    <li><a target="_blank" rel="noopener noreferrer" href={COMPANY_MAPS_SEARCH_URL}><Icon icon="weui:location-filled" width={20} height={20}/>Address: {COMPANY_ADDRESS_LINE}</a></li>
                                    <li><a href={COMPANY_PHONE_HREF}><Icon icon="ic:round-call" width={20} height={20}/>Phone: {COMPANY_PHONE_DISPLAY}</a></li>
                                    {/* <li><Link to="javascript:void(0)"><Icon icon="mdi:web" width={20} height={20}/> refinedspace.com</Link></li> */}
                                </ul>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="footer-column">
                                <h2 className="footer-heading">licensed Bonded & Insured</h2>
                                <Image className="footerbrand_img" src={licenceBondImage} alt=""/>
                            </div>
                        </Col>
                        {/* <Col lg={3} className="text-lg-end">
                            <div className="footer-column d-inline-block ">
                                <h2 className="footer-heading text-lg-start">Awards & Certifications</h2>
                                <div className="d-flex flex-wrap gap-3">
                                    <Image src={Awards} className="img-fluid" alt="" />
                                    <Image src={Awards} className="img-fluid" alt="" />
                                </div>
                            </div>
                        </Col> */}

                    </Row>
                </div>

                <div className="footercopyright">
                    <p className="mb-0 footercopyright-line">
                        {COMPANY_FOOTER_LICENSE_LINE} · © {new Date().getFullYear()} {COMPANY_NAME}. All rights reserved.
                    </p>
                    <div className="copyrightmenu">
                        <a href={appPath("/privacy-policy")} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                        <a href={appPath("/terms-of-service")} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
                    </div>
                </div>
            </Container>
        </footer>
    )
}

export default Footer;